import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://passadc.com";

// Fallback title/description per public route. Pages with their own SEO hook
// (guides, ADC hub) override these after mount; this guarantees nothing
// public ever ships with the homepage title (the /terms bug in Search).
const ROUTE_META = {
  "/": ["ADC Written Exam Preparation | Part 1 MCQs & Mock Exams | PassADC",
        "Independent study and practice platform for the Australian Dental Council Written Examination (ADC Part 1). Scenario-based MCQs, structured study and readiness tracking aligned to the current ADC blueprint."],
  "/terms": ["Terms of Service | PassADC", "Terms governing use of PassADC, the independent ADC written exam preparation platform."],
  "/privacy": ["Privacy Policy | PassADC", "How PassADC collects, uses and protects your personal information."],
  "/refund": ["Refund Policy | PassADC", "How PassADC refunds work: a free 7-day Pro trial, cancel anytime, case-by-case refunds and the 80% Readiness Commitment."],
  "/contact": ["Contact PassADC", "Get in touch with the PassADC team."],
  "/guarantee": ["Pass Guarantee | PassADC", "How the PassADC pass guarantee works."],
  "/pricing": ["Pricing | PassADC", "PassADC Pro: AUD $19/month, or the March 2027 Pass for $89 one-time. Start free."],
  "/mock-event": ["Free Live ADC Mock Exam | PassADC", "Sit a free, timed, blueprint-weighted ADC written exam mock."],
  "/readiness": ["Free ADC Readiness Check | PassADC", "30-question ADC readiness check weighted to the official blueprint. Free, no card."],
  "/login": ["Log in | PassADC", "Log in to PassADC."],
  "/register": ["Create your free account | PassADC", "Start preparing for the ADC written examination free."],
};

// Logged-in app surfaces: never index.
const NOINDEX_PREFIXES = ["/dashboard", "/practice", "/study", "/learn/", "/account", "/admin", "/billing",
  "/mock", "/trials", "/flashcards", "/progress", "/welcome", "/tutor", "/osce", "/reset-password"];

function upsert(selector, create, attr, value) {
  let el = document.querySelector(selector);
  if (!el) { el = create(); document.head.appendChild(el); }
  el.setAttribute(attr, value);
}

export const RouteMeta = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const clean = pathname.replace(/\/+$/, "") || "/";
    const noindex = NOINDEX_PREFIXES.some((p) => clean === p.replace(/\/$/, "") || clean.startsWith(p));
    const [title, description] = ROUTE_META[clean] || [];
    if (title) {
      document.title = title;
      upsert('meta[name="description"]', () => Object.assign(document.createElement("meta"), { name: "description" }), "content", description);
      upsert('meta[property="og:title"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:title"); return m; }, "content", title.replace(" | PassADC", ""));
      upsert('meta[property="og:description"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:description"); return m; }, "content", description);
    }
    upsert('link[rel="canonical"]', () => Object.assign(document.createElement("link"), { rel: "canonical" }), "href", `${SITE}${clean === "/" ? "/" : clean}`);
    upsert('meta[property="og:url"]', () => { const m = document.createElement("meta"); m.setAttribute("property", "og:url"); return m; }, "content", `${SITE}${clean === "/" ? "/" : clean}`);
    upsert('meta[name="robots"]', () => Object.assign(document.createElement("meta"), { name: "robots" }), "content", noindex ? "noindex, nofollow" : "index, follow");
  }, [pathname]);
  return null;
};
